/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'picture': {
    width: 16,
    height: 16,
    viewBox: '0 0 480 480',
    data: '<path pid="0" d="M440 72H40C17.92 72.026.026 89.92 0 112v256c.026 22.08 17.92 39.974 40 40h400a37.03 37.03 0 0 0 6.696-.584C465.945 404.194 480.037 387.517 480 368V112c-.026-22.081-17.92-39.974-40-40zM40 392c-12.435-.002-22.81-9.501-23.904-21.888L175.6 265.824 337.808 392H40zm424-24c.013 11.742-8.492 21.761-20.08 23.656A21.746 21.746 0 0 1 440 392h-76.136l-105.992-82.488 94.784-75.792L464 300.528V368zm0-86.128l-107.88-64.728a8 8 0 0 0-9.12.608l-102.136 81.68-63.96-49.744a8 8 0 0 0-9.28-.384L16 351.056V112c0-13.255 10.745-24 24-24h400c13.255 0 24 10.745 24 24v169.872z"/><path pid="1" d="M240 120c-26.51 0-48 21.49-48 48 .026 26.499 21.501 47.974 48 48 26.51 0 48-21.49 48-48s-21.49-48-48-48zm0 80c-17.673 0-32-14.327-32-32s14.327-32 32-32c17.673 0 32 14.327 32 32s-14.327 32-32 32z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/picture.js